// extracted by mini-css-extract-plugin
export default {"title":"style_title__Bw6YF","crossIcon":"style_crossIcon__cl1SO","headingContainer":"style_headingContainer__MLreZ"};